import { useMemo } from 'react';
import css from './Addon.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../../../common/utils/styles';

const Addon = (props) => {
    const { compStyle = {}, addon, isLast } = props;
    const { stylers, classes } = generateCompStylers(compStyle);

    const addonResult = useMemo(() => {
        if (typeof addon === 'string' && addon.length >= 34) {
            const part1 = addon.slice(0, 12);
            const part2 = addon.slice(12, -10);
            const part3 = addon.slice(-10);
            return (
                <>
                    {part1}
                    <span className={css.desktopPart}>{part2}</span>
                    <span className={css.mobPart}>...</span>
                    {part3}
                </>
            );
        }
        return addon;
    }, [addon]);
    return (
        <div
            style={stylers.addon}
            className={classnames(css.formControlAddon, isLast && css.formControlAddonLast, classes.addon)}
        >
            {addonResult}
        </div>
    );
};
export default Addon;
